import ActivityTypeStyleMapper from 'pages/activity_details_2/views/utils/ActivityTypeStyleMapper';
import NavigationUtil from 'utils/NavigationUtil';
import Globalize from 'globalize';
import Personalizer from 'personalizer';
import { isChinaUser } from 'utils/ChinaUtil';
import { ACTIVITY_HIGHLIGHT_MARKERS } from 'utils/activity/ActivityDetailsUtils';

var START_MARKER_WIDTH = 33;
var START_MARKER_HEIGHT = 50;
var START_MARKER_HEIGHT_OFFSET = 5;

var END_MARKER_WIDTH = 33;
var END_MARKER_HEIGHT = 50;
var END_MARKER_HEIGHT_OFFSET = 5;

var PLAYER_POSITION_MARKER_WIDTH = 16;
var PLAYER_POSITION_MARKER_HEIGHT = 16;

var SEGMENT_MARKER_HEIGHT = 11;
var SEGMENT_MARKER_WIDTH = 11;
var SEGMENT_ANCHOR_OFFSET = 0;

var ACTIVITY_MARKER_WIDTH = 26;
var ACTIVITY_MARKER_HEIGHT = 26;
var ACTIVITY_MARKER_HEIGHT_OFFSET = 26;

var JUMP_MARKER_WIDTH = 24;
var JUMP_MARKER_HEIGHT = 24;
var JUMP_MARKER_HEIGHT_OFFSET = 6;

let TYPED_SPLIT_MARKER_WIDTH = 20;
let TYPED_SPLIT_MARKER_HEIGHT = 20;
let TYPED_SPLIT_HEIGHT_OFFSET = 6;

export default {
    getSmallStartMarkerOptions: function(parentActivityType) {
        var filename = NavigationUtil.url('/images/map/large/map_marker_start.svg');
        if (parentActivityType) {
            filename = NavigationUtil.url(
                '/images/map/large/' + ActivityTypeStyleMapper.mapStartPin(parentActivityType)
            );
        }

        return {
            iconURL: filename,
            iconAnchor: {
                x: Math.ceil(START_MARKER_WIDTH / 4),
                y: START_MARKER_HEIGHT / 2 - START_MARKER_HEIGHT_OFFSET / 2
            },
            iconSize: {
                width: START_MARKER_WIDTH / 2,
                height: START_MARKER_HEIGHT / 2
            },
            cursor: 'default',
            zIndex: 91
        };
    },

    getStartMarkerOptions: function(parentActivityType) {
        var filename = NavigationUtil.url('/images/map/large/map_marker_start.svg');
        if (parentActivityType) {
            filename = NavigationUtil.url(
                '/images/map/large/' + ActivityTypeStyleMapper.mapStartPin(parentActivityType)
            );
        }

        return {
            iconURL: filename,
            iconAnchor: {
                x: Math.ceil(START_MARKER_WIDTH / 2),
                y: START_MARKER_HEIGHT - START_MARKER_HEIGHT_OFFSET
            },
            iconSize: { width: START_MARKER_WIDTH, height: START_MARKER_HEIGHT },
            cursor: 'default',
            zIndex: 91
        };
    },

    getEndMarkerOptions: function() {
        return {
            iconURL: NavigationUtil.url('/images/map/large/map_marker_end.svg'),
            iconAnchor: {
                x: Math.ceil(END_MARKER_WIDTH / 2),
                y: END_MARKER_HEIGHT - END_MARKER_HEIGHT_OFFSET
            },
            iconSize: { width: END_MARKER_WIDTH, height: END_MARKER_HEIGHT },
            cursor: 'default',
            zIndex: 90
        };
    },

    getPlayerPositionMarkerOptions: function() {
        return {
            iconURL: NavigationUtil.url('/images/map/map_marker_player.svg'),
            iconAnchor: {
                x: Math.ceil(PLAYER_POSITION_MARKER_WIDTH / 2),
                y: Math.ceil(PLAYER_POSITION_MARKER_HEIGHT) - PLAYER_POSITION_MARKER_HEIGHT / 2
            },
            iconSize: {
                height: PLAYER_POSITION_MARKER_HEIGHT,
                width: PLAYER_POSITION_MARKER_WIDTH
            },
            cursor: 'pointer',
            zIndex: 90
        };
    },

    getLapMarkerOptions: function(iconURL) {
        return {
            iconUTL: iconURL,
            iconAnchor: {
                x: Math.ceil(END_MARKER_WIDTH / 2),
                y: Math.ceil(END_MARKER_HEIGHT)
            },
            iconSize: { height: START_MARKER_HEIGHT, width: START_MARKER_WIDTH },
            cursor: 'pointer',
            zIndex: 91,
            visible: true
        };
    },

    getSegmentStartMarkerOptions: function() {
        return {
            iconURL: NavigationUtil.url('/images/map/map_marker_start_small.svg'),
            iconAnchor: {
                x: Math.ceil(SEGMENT_MARKER_WIDTH / 2) - SEGMENT_ANCHOR_OFFSET,
                y: Math.ceil(SEGMENT_MARKER_HEIGHT / 2) - SEGMENT_ANCHOR_OFFSET
            },
            iconSize: { height: SEGMENT_MARKER_HEIGHT, width: SEGMENT_MARKER_WIDTH },
            zIndex: 89
        };
    },

    getSegmentEndMarkerOptions: function() {
        return {
            iconURL: NavigationUtil.url('/images/map/map_marker_end_small.svg'),
            iconAnchor: {
                x: Math.ceil(SEGMENT_MARKER_WIDTH / 2) - SEGMENT_ANCHOR_OFFSET,
                y: Math.ceil(SEGMENT_MARKER_HEIGHT / 2) - SEGMENT_ANCHOR_OFFSET
            },
            iconSize: { height: SEGMENT_MARKER_HEIGHT, width: SEGMENT_MARKER_WIDTH },
            zIndex: 89
        };
    },

    getActivityMarkerOptions: function(parentActivityType) {
        if (!parentActivityType) {
            throw 'activity type required';
        }

        var filename = NavigationUtil.url(
            '/images/map/large/' + ActivityTypeStyleMapper.mapStartPin(parentActivityType)
        );

        return {
            iconURL: filename,
            iconAnchor: {
                x: Math.ceil(ACTIVITY_MARKER_WIDTH / 2),
                y: ACTIVITY_MARKER_HEIGHT - ACTIVITY_MARKER_HEIGHT_OFFSET
            },
            iconSize: {
                width: ACTIVITY_MARKER_WIDTH,
                height: ACTIVITY_MARKER_HEIGHT
            },
            cursor: 'default',
            zIndex: 91
        };
    },

    getJumpMarkerOptions: function() {
        var filename = NavigationUtil.url('/images/feature/mtb/jump.svg');

        return {
            iconURL: filename,
            iconAnchor: {
                x: Math.ceil(JUMP_MARKER_WIDTH / 2),
                y: JUMP_MARKER_HEIGHT - JUMP_MARKER_HEIGHT_OFFSET
            },
            iconSize: { width: JUMP_MARKER_WIDTH, height: JUMP_MARKER_HEIGHT },
            cursor: 'default',
            zIndex: 91,
            markerType: ACTIVITY_HIGHLIGHT_MARKERS.JUMPS
        };
    },

    getClimbMapIcon: function() {
        return {
            iconURL: NavigationUtil.url('/images/feature/climb-pro/climb_marker.svg'),
            iconAnchor: {
                x: Math.ceil(JUMP_MARKER_WIDTH / 2),
                y: JUMP_MARKER_HEIGHT - JUMP_MARKER_HEIGHT_OFFSET
            },
            iconSize: { width: JUMP_MARKER_WIDTH, height: JUMP_MARKER_HEIGHT },
            zIndex: 89,
            markerType: ACTIVITY_HIGHLIGHT_MARKERS.CLIMBS
        };
    },

    getTransitionTypedSplitsMarkerOptions: function() {
        var filename = NavigationUtil.url('/images/feature/transition/transition.svg');

        return {
            iconURL: filename,
            iconAnchor: {
                x: Math.ceil(TYPED_SPLIT_MARKER_WIDTH / 2),
                y: TYPED_SPLIT_MARKER_HEIGHT - TYPED_SPLIT_HEIGHT_OFFSET
            },
            iconSize: { width: TYPED_SPLIT_MARKER_WIDTH, height: TYPED_SPLIT_MARKER_HEIGHT },
            cursor: 'default',
            zIndex: -1000 // ensures the laps/splits numbered markers are on top of these markers
        };
    },

    getTypedSplitsMarkerOptions: function(iconURL) {
        var filename = NavigationUtil.url(iconURL);

        return {
            iconURL: filename,
            iconAnchor: {
                x: Math.ceil(TYPED_SPLIT_MARKER_WIDTH / 2),
                y: TYPED_SPLIT_MARKER_HEIGHT - TYPED_SPLIT_HEIGHT_OFFSET
            },
            iconSize: { width: TYPED_SPLIT_MARKER_WIDTH, height: TYPED_SPLIT_MARKER_HEIGHT },
            cursor: 'default',
            zIndex: -1000 // ensures the laps/splits numbered markers are on top of these markers
        };
    },

    userInChina: function() {
        return isChinaUser();
    },

    isMapProviderValid: function(mapProviderString) {
        if (!this.isBaiduEnabled() && mapProviderString === 'BAIDU_V_1_4') {
            return false;
        }

        return true;
    },

    isBaiduEnabled: function() {
        var locale = Globalize.cultureSelector.replace('-', '_');
        var url = window.location.href;
        //garmin.cn
        if (url.indexOf('garmin.cn') != -1) {
            return true;
        }

        if (locale != 'zh_TW' && locale != 'zh_CN') {
            return false;
        }

        return true;
    },

    /**
     * We want to have a standardized format for the longitude parameter of any point. To keep things similar to the Default Map View, we will use "lon".
     * Given a point object, with values for both latitude and longitude, the function returns a standardized object with regards to the longitude parameter
     * In short - converts "lng" to "lon"
     * @param point {Object}
     * @private
     */
    getStandardizedPoint: function(point) {
        var standardizedPoint = {};

        if (!point || !point.hasOwnProperty('lat')) {
            return;
        }

        standardizedPoint.lat = point.lat;

        if (point.hasOwnProperty('lng')) {
            standardizedPoint.lon = point.lng;
        } else if (point.hasOwnProperty('lon')) {
            standardizedPoint.lon = point.lon;
        } else {
            return;
        }

        return standardizedPoint;
    },

    getBigSegmentStartMarkerOptions: function() {
        return {
            iconUrl: '/modern/images/map/map-marker-start.svg',
            shadowUrl: '',
            iconSize: [30, 45],
            iconAnchor: [16, 40],
            className: 'active has-tooltip',
            html: '<span class="course-pt course-pt-start active has-tooltip" title=""></span>'
        };
    },

    getBigSegmentEndMarkerOptions: function() {
        return {
            iconUrl: '/modern/images/map/map-marker-end.svg',
            shadowUrl: '',
            iconSize: [30, 45],
            iconAnchor: [16, 40],
            className: 'active has-tooltip',
            html: '<span class="course-pt course-pt-finish active has-tooltip" title=""></span>'
        };
    },

    getSpeedPaceLayer: function(activityType) {
        const speedType = Personalizer.getSpeedTypeFromActivityType(activityType);
        let layerValue = 'SPEED';

        switch (speedType) {
            case Personalizer.SpeedTypes.Flying:
            case Personalizer.SpeedTypes.Speed:
            case Personalizer.SpeedTypes.RowingSpeed:
            case Personalizer.SpeedTypes.NauticalSpeed:
            case Personalizer.SpeedTypes.ResortSkiSpeed:
                layerValue = 'SPEED';
                break;
            case Personalizer.SpeedTypes.Pace:
            case Personalizer.SpeedTypes.RowingPace:
                layerValue = 'PACE';
                break;
            case Personalizer.SpeedTypes.SwimSpeed:
                layerValue = 'SPEED';
                break;
            case Personalizer.SpeedTypes.SwimPace:
                layerValue = 'PACE';
                break;
            default:
                layerValue = 'SPEED';
        }

        return layerValue;
    },

    getTypedSplitMarkerWidthHeight: function() {
        return {
            width: TYPED_SPLIT_MARKER_WIDTH,
            height: TYPED_SPLIT_MARKER_HEIGHT
        };
    }
};
